const PAGE_COURSE_LIST = 'Courses'
const PAGE_MASTER = PAGE_COURSE_LIST
const PAGE_LOGIN = 'Login'
const PAGE_APPLICATION_LIST = 'ApplicationList'
const PAGE_CREATE_COURSE = 'CreateCourse'

export {
  PAGE_MASTER,
  PAGE_LOGIN,
  PAGE_COURSE_LIST,
  PAGE_APPLICATION_LIST,
  PAGE_CREATE_COURSE,
}



// WEBPACK FOOTER //
// ./client/masteradmin/router/routeNames.js